import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  IconButton,
  Box,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import CloseIcon from "@mui/icons-material/Close";

/**
 * The members cap was reached. viewer "supplier" (default): the supplier tried
 * to join another community. viewer "cm": a community manager tried to approve
 * a supplier who is at its cap — supplierName is shown and the request closed.
 */
const MaximumCapacityReachedModal = ({
  open,
  onClose,
  maxClients,
  communityName,
  viewer = "supplier",
  supplierName,
}) => {
  const { t } = useTranslation("maximum-capacity-reached");
  const isCm = viewer === "cm";

  return (
    <Dialog
      open={open}
      PaperProps={{
        sx: {
          borderRadius: "12px",
          maxWidth: "556px",
          width: "100%",
        },
      }}
      onClose={(_event, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          return;
        }
        onClose();
      }}
      disableEscapeKeyDown
      maxWidth="sm"
      fullWidth
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: "24px",
          py: "16px",
          borderBottom: "1px solid rgba(234, 234, 234, 1)",
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: 600,
            color: "rgba(47, 43, 61, 0.9)",
            fontSize: "18px",
            p: 0,
            m: 0,
          }}
        >
          {isCm ? t("cm_title") : t("title")}
        </DialogTitle>
        <IconButton onClick={onClose} size="small">
          <CloseIcon fontSize="small" sx={{ color: "#666" }} />
        </IconButton>
      </Box>

      <DialogContent sx={{ p: "24px", pt: "18px" }}>
        {isCm ? (
          <Typography
            sx={{
              fontSize: "15px",
              fontWeight: 400,
              color: "rgba(47, 43, 61, 0.9)",
              lineHeight: "160%",
            }}
          >
            {t("cm_message", { name: supplierName })}
          </Typography>
        ) : (
          <>
            <Typography
              variant="h5"
              sx={{
                mb: "16px",
                fontSize: "18px",
                fontWeight: 500,
                color: "rgba(47, 43, 61, 0.9)",
                lineHeight: "28px",
              }}
            >
              {t("congratulations")} <br /> {t("message")}
            </Typography>

            <Typography
              sx={{
                fontSize: "15px",
                fontWeight: 400,
                color: "rgba(47, 43, 61, 0.9)",
                lineHeight: "160%",
              }}
            >
              {t("sub_message_part_1")} {maxClients}, {t("sub_message_part_2")}{" "}
              {communityName} {t("sub_message_part_3")}
            </Typography>
          </>
        )}
      </DialogContent>

      <DialogActions
        sx={{ px: "24px", py: "12px", justifyContent: "flex-start" }}
      >
        <Button
          variant="contained"
          onClick={onClose}
          sx={{
            background: "#808390",
            color: "white",
            borderRadius: "8px",
            textTransform: "none",
            fontSize: "15px",
            fontWeight: 500,
            px: "24px",
            py: "8px",
            boxShadow: "none !important",
            "&:hover": {
              backgroundColor: "#6E707C",
              boxShadow: "none",
            },
          }}
        >
          {isCm ? t("cm_ok") : t("back")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MaximumCapacityReachedModal;
